import type { IntlMessage } from '@rovo-extension/i18n';
import { defineMessages } from 'react-intl';

type MessageKey = 'next' | 'done' | 'goBack' | 'dismiss';

export const messages: Record<MessageKey, IntlMessage> = defineMessages({
	next: {
		id: 'rovo-extension.tour.action.next',
		defaultMessage: 'Next',
		description: 'Button text to proceed to next tour item',
	},
	done: {
		id: 'rovo-extension.tour.action.done',
		defaultMessage: 'Done',
		description:
			'The text is shown on a primary button in the onboarding tour overlay when the user reaches the final step, allowing them to finish and close the tour.',
	},
	goBack: {
		id: 'rovo-extension.tour.action.go-back',
		defaultMessage: 'Go back',
		description: 'Button text to go back to previous tour item',
	},
	dismiss: {
		id: 'rovo-extension.tour.action.dismiss',
		defaultMessage: 'Dismiss',
		description:
			'The text is shown on a button in the onboarding tour overlay that allows the user to close and skip the tour at any point without completing all steps.',
	},
});
